import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiUser, FiMail, FiPhone, FiArrowRight } = FiIcons;

const RegistrationModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: ''
  });

  const WEBHOOK_URL = "https://services.leadconnectorhq.com/hooks/so5Q2Nu9nHUt6xGc9h1D/webhook-trigger/960c9071-a958-438b-9be6-ae577ce98634";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          source: 'Webinar Registration Andrea Zuccarini',
          event_date: '2025-01-30 21:00'
        }),
      });

      if (window.fbq) {
        window.fbq('track', 'Lead', {
          content_name: 'Webinar Registration',
          status: 'success'
        });
      }

      setLoading(false);
      onClose();
      navigate('/thank-you');
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Registration Error:', error);
      setLoading(false);
      onClose();
      navigate('/thank-you');
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/90 backdrop-blur-xl"
          />
          <motion.div 
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-lg bg-slate-900 border border-white/10 rounded-[2.5rem] p-8 md:p-12 shadow-[0_0_100px_rgba(249,115,22,0.2)]"
          >
            <button onClick={onClose} className="absolute top-6 right-6 text-slate-400 hover:text-white transition-colors">
              <SafeIcon icon={FiX} className="text-2xl" />
            </button>

            <div className="text-center mb-8">
              <h3 className="text-3xl font-black text-white uppercase tracking-tighter mb-4">
                Assicura il tuo <span className="text-orange-500 italic">Posto</span>
              </h3>
              <p className="text-slate-400 font-medium">
                Inserisci i tuoi dati per ricevere il link di accesso esclusivo al webinar.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="relative">
                <div className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-500">
                  <SafeIcon icon={FiUser} />
                </div>
                <input 
                  required
                  name="fullName"
                  type="text"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Nome Completo"
                  className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-12 pr-6 text-white placeholder:text-slate-600 focus:outline-none focus:border-orange-500 transition-colors"
                />
              </div>

              <div className="relative">
                <div className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-500">
                  <SafeIcon icon={FiMail} />
                </div>
                <input 
                  required
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="La tua migliore Email"
                  className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-12 pr-6 text-white placeholder:text-slate-600 focus:outline-none focus:border-orange-500 transition-colors"
                />
              </div>

              <div className="relative">
                <div className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-500">
                  <SafeIcon icon={FiPhone} />
                </div>
                <input 
                  required
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Numero di Telefono"
                  className="w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-12 pr-6 text-white placeholder:text-slate-600 focus:outline-none focus:border-orange-500 transition-colors"
                />
              </div>

              <button 
                type="submit"
                disabled={loading}
                className="w-full btn-premium text-white py-5 rounded-2xl font-black text-lg flex items-center justify-center space-x-3 disabled:opacity-50 disabled:cursor-not-allowed group"
              >
                {loading ? (
                  <div className="flex items-center space-x-3">
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    <span>INVIO IN CORSO...</span>
                  </div>
                ) : (
                  <>
                    <span>VOGLIO PARTECIPARE</span>
                    <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
                  </>
                )}
              </button>
            </form>
            
            <p className="text-[10px] text-slate-500 text-center mt-6 uppercase tracking-widest font-bold">
              Posti limitati per la sessione live
            </p>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default RegistrationModal;